// The local universe: Dexie (IndexedDB) is the primary store, offline-first
// and anonymous-first (docs/ARCHITECTURE.md). The only module importing dexie.

import Dexie, { type EntityTable } from "dexie";
import type { DnaRecord, Edge, Obj } from "./types";
import type { Intent } from "./types";
import type { Op } from "@/music/ops";

export interface StoredOpBatch {
  id: string; // ULID: time-ordered
  draftId: string;
  seq: number; // local sequence; server-final in Jams
  ops: Op[];
  opsVersion: number;
  intent?: Intent;
  actorId: string;
  at: number;
}

export interface StoredBlob {
  key: string;
  data: Blob;
}

export interface KV {
  key: string;
  value: unknown;
}

class BeatDraftDb extends Dexie {
  objects!: EntityTable<Obj, "id">;
  edges!: EntityTable<Edge, "id">;
  ops!: EntityTable<StoredOpBatch, "id">;
  dna!: EntityTable<DnaRecord, "objectId">;
  blobs!: EntityTable<StoredBlob, "key">;
  kv!: EntityTable<KV, "key">;

  constructor() {
    super("beatdraft");
    this.version(1).stores({
      objects: "id, kind, draftId, ownerId, status, updatedAt, name",
      edges: "id, from, to, type, at",
      ops: "id, draftId, [draftId+seq], at",
      dna: "objectId, updatedAt",
      blobs: "key",
      kv: "key",
    });
  }
}

export const db = new BeatDraftDb();
